import Immutable from 'immutable';
import moment from 'moment';

import ClassFactory from 'sharedreact/utils/ClassFactory';
import MomentSupport from 'sharedreact/utils/MomentSupport';

const Content: {
  objType: string,
  value: moment.Moment | null
} = {
  objType: 'TypedDate',
  value: null
};

function convertDate (json: object): object {
  if (Immutable.isMap(json)) {
    const value: any = json.get('value');
    if (value instanceof String || typeof value === 'string') {
      let typedDateMap: Immutable.Map<string, any> = Immutable.Map();
      typedDateMap.set('objType', 'TypedDate');
      typedDateMap.set('value', MomentSupport.stringToMoment(value));
      
      return typedDateMap;
    }
  }

  return json;
}

class TypedDate extends Immutable.Record(Content) {
  constructor (json: object) {
    super(convertDate(json));
  }

  static fromJS (json: object): TypedDate {
    return ClassFactory.createFromJson(json, TypedDate);
  }

  static create (value: moment.Moment): TypedDate {
    return new TypedDate({value: value});
  }
}

export default TypedDate;
